import { render, staticRenderFns } from "./UserMassInsert.vue?vue&type=template&id=3819ef7c&scoped=true"
import script from "./UserMassInsert.vue?vue&type=script&lang=ts"
export * from "./UserMassInsert.vue?vue&type=script&lang=ts"
import style0 from "./UserMassInsert.vue?vue&type=style&index=0&id=3819ef7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819ef7c",
  null
  
)

export default component.exports